import React, { useState } from 'react';
import './PageToggleButton.css';

interface PageToggleButtonProps {
  number: number;
  isActive: boolean;
  onClick: () => void;
  color?: 'awasi' | 'off-white';
  className?: string;
}

export const PageToggleButton: React.FC<PageToggleButtonProps> = ({
  number,
  isActive,
  onClick,
  color = 'off-white',
  className = ''
}) => {
  const [isHovered, setIsHovered] = useState(false);

  // Only show frame for active or hovered states
  const showFrame = isActive || isHovered;
  const state = isActive ? 'selected' : 'hover';
  const framePath = showFrame ? `/Buttons/Page Toggle Frames/state=${state}, color=${color}.svg` : null;

  return (
    <button
      className={`page-toggle-button ${isActive ? 'page-toggle-button--active' : ''} page-toggle-button--${color} ${className}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label={`View page ${number}`}
      aria-current={isActive ? 'page' : undefined}
    >
      {framePath && (
        <svg 
          className="page-toggle-button__frame"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 37 39"
        >
          <image 
            href={framePath}
            x="0" 
            y="0" 
            width="37" 
            height="39"
            preserveAspectRatio="xMidYMid meet"
          />
        </svg>
      )}
      <span className="page-toggle-button__number">{number}</span>
    </button>
  );
};